/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {FC} from 'react'
import Card from '@app/components/game-player/domino/card'
import Image from 'next/image'
import clsx from 'clsx'
import CardDetails from '@app/components/game-player/domino/card/details'
import s from './non-desktop.module.css'
import BaseInfo from '@app/components/game-player/domino/card/details/base-info'
import {GameDetail} from '@app/components/game-player/types/game'
import Tags from '@app/components/game-player/domino/game-tags'
import analytics from '@app/components/game-player/domino/card/telemetry/events'
import GameLink from '@app/components/custom-links/game-link/'
import {useRecentlyPlayed} from '@gzp/stores/use-recently-played-games'
import {useGamePreference} from '../../context/preferences'
import {LanguageCodes} from '@app/i18n/settings'

export interface GameCardProps {
  game: GameDetail
  titleCss?: string
  subTitleCss?: string
  cardCss?: string
  index?: number
  layout?: string
  lang: LanguageCodes
  propertyCode: string
  subId: string
}

const SimilarGameMobile: FC<GameCardProps> = ({game, titleCss, subTitleCss, cardCss, lang, propertyCode, subId}) => {
  const {add} = useRecentlyPlayed() // this is for compatiblity with pages code
  const {updateLastPlayed} = useGamePreference()
  const css = clsx(s.card_wrap, cardCss)
  const imgUrl = `https://static.gamezop.com/${game.code}/l/cover.jpg`

  return (
    <Card className={css}>
      <Tags game={game} />
      <GameLink
        gameCode={game.code}
        gameName={game.name}
        propertyCode={propertyCode}
        target='_blank'
        onClick={() => {
          analytics.sendOnGameCardClick({
            gameCode: game.code,
            categoryName: game.categoryKey,
            layoutName: 'game-player',
          })
          add(game.code) // hook from store (pages router)
          updateLastPlayed(game.code, propertyCode, subId) // context (app router)
        }}
      >
        <Image
          src={imgUrl}
          alt={game.name}
          className={s.image}
          sizes='(max-width: 576px) 21.5vw, (max-width: 1000px) 42vw, (min-width: 1000px) 220px'
          fill
          objectFit='cover'
        />
        <CardDetails className={s.details}>
          <BaseInfo css='text-center' title={game.name} subTitle={''} lang={lang} {...{titleCss, subTitleCss}} />
        </CardDetails>
      </GameLink>
    </Card>
  )
}

export default SimilarGameMobile
